import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

import WithRecaptchaProvider from '~/auth/components/WithRecaptchaProvider'
import Register from '~/auth/pages/Register.page'
import { usePageTitle } from '~/utils/tags'
import Metatags from '~/components/Metadata/Metatags'
import GuestGuard from '~/components/GuestGuard'
import { useSignupScenario } from '~/auth/hooks/useSignupScenario'
import { RegisterProvider } from '~/auth/contexts/RegisterContext'
import { getAllCountries, getRunningQueriesThunk } from '~/redux/apis/countries-api'
import { GetProps } from '~/utils/pageWrapper/types'
import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'

export default function RegisterPage(): React.ReactElement {
  const { t } = useTranslation('register')
  const router = useRouter()
  const { signUpScenario } = useSignupScenario()
  const redirect = router.query.from as string | undefined

  return (
    <div>
      <Metatags metaDescription={t('metaDescription')} noindex title={usePageTitle(t('title'))} />
      <GuestGuard redirect={redirect}>
        <WithRecaptchaProvider>
          <RegisterProvider signUpScenario={signUpScenario}>
            <Register />
          </RegisterProvider>
        </WithRecaptchaProvider>
      </GuestGuard>
    </div>
  )
}
export const getProps: GetProps = (store) => async () => {
  store.dispatch(getAllCountries.initiate())
  await Promise.all(store.dispatch(getRunningQueriesThunk()))
  return {
    props: {
      namespaces: [
        'errors',
        'fields',
        'multgame',
        'register',
        'generics',
        'footer',
        'registerAccount',
        'validation',
        'settings',
        'welcome',
        'subscription',
        'menu',
      ],
    },
  }
}

export const getStaticProps = getStaticPropsWrapper(getProps)
